<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <v-card
      :elevation="hover ? 16 : 2"
      class="mx-auto"
      max-width="700"
      :to="{ name: 'article', params: { id: cardData.id }}"
    >
      <v-card-title class="fill-height">
        <div>{{ cardData.data.title[0].text }}</div>
        <v-spacer></v-spacer>
        <v-chip outlined color="pink" class="text-uppercase float-right">{{ $t(`common.${cardData.data.type}`) }}</v-chip>
      </v-card-title>
      <v-card-subtitle>
        <v-list-item class="px-0">
          <v-list-item-avatar color="primary"><v-img src="../assets/Navigate_symbol_no_background_RGB_small.png"></v-img></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="">Navigate Team</v-list-item-title>
            <v-list-item-subtitle>{{ cardData.last_publication_date | formatUTCLocalDate }} · {{ readingTime() }}{{ $t('common.reading-time')}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-subtitle>
      <v-img
        v-if="cardData.cover"
        :src="'https://res.cloudinary.com/twodm/image/fetch/'+cardData.cover"
        height="194"
      ></v-img>
      <v-card-text>
        <v-clamp autoresize :max-lines="3">{{ summary }}</v-clamp>
      </v-card-text>
      <v-card-actions class="primary accent-4">
        <v-spacer></v-spacer>
        <v-btn
          text
          color="white"
        >
          {{ $t('common.read')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
import VClamp from 'vue-clamp';

export default {
  name: 'NewsCard',
  props: {
    cardData: Object,
  },
  components: {
    VClamp,
  },
  data: () => ({
    summary: '',
  }),
  methods: {
    readingTime() {
      this.summary = this.$prismic.richTextAsPlain(this.cardData.data.content);
      const textLength = this.summary.length;
      const readTime = Math.round(textLength / 400);
      if (readTime > 1) {
        return `${readTime}`;
      }
      return '1';
    },
  },
};
</script>

<style scoped>
</style>
